import React, { Component } from "react";
import DashboardForm from "../DashboardForm/DashboardForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : DashboardPage
Description : Componente que contienen el formulario de la pantalla Dashboard
Date Autor Modification
================================================================================
1/10/2021 Santiago Coca Rojas Creación – Se llama al componente DashboardForm
================================================================================ */
class DashboardPage extends Component {
    render() {
        return (
            <div>
                <DashboardForm />
            </div>
        )
    }
}

export default DashboardPage;